export default {"src":"/_next/static/media/wifi.cf13a8b2.svg","height":45,"width":51,"blurWidth":0,"blurHeight":0};